export type BrokerNerdsBarkerCoreEnumsRounding = (typeof BrokerNerdsBarkerCoreEnumsRounding)[keyof typeof BrokerNerdsBarkerCoreEnumsRounding];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsRounding = {
  None: 'None',
  AlwaysDown: 'AlwaysDown',
  AlwaysUp: 'AlwaysUp',
  Nearest: 'Nearest',
} as const;
